<template>
  <div class="info_warp" v-show="info.questions.length>0" ref="modalWrap">
 
        <div class="top">
      <img src="@/static/topCard/CaretCircleLeft.png"
           @click="back"
           alt="">
      <div  >做题详情</div>
          <img src="@/static/doPaper/card.png"
               @click="card"
               alt=""
               title='答题卡'>
    </div>

    <TimeForm ref="timeFormRef" />
    <!-- <ExportPaper v-if='info.user_paper_id'
                 :id='info.user_paper_id' />
    <div class="paper_id">试卷ID:{{info.user_paper_id}}</div> -->

    <div class="paper_id">
      <div v-if="startTimeing">
        <svg v-show="leftTimeContent!=='00:00:00'" style="cursor: pointer;" @click="setTimeing(false)" width="24rem" height="24rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm224-72l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144c0-13.3 10.7-24 24-24s24 10.7 24 24zm112 0l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144c0-13.3 10.7-24 24-24s24 10.7 24 24z"/></svg>
      </div>
      <div v-else>
        <svg  style="cursor: pointer;" @click="setTimeing(true)" width="24rem" height="24rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c7.6-4.2 16.8-4.1 24.3 .5l144 88c7.1 4.4 11.5 12.1 11.5 20.5s-4.4 16.1-11.5 20.5l-144 88c-7.4 4.5-16.7 4.7-24.3 .5s-12.3-12.2-12.3-20.9l0-176c0-8.7 4.7-16.7 12.3-20.9z"/></svg>
      </div>
      {{leftTimeContent=='00:00:00'?'':leftTimeContent}}
    </div>

    <div class="source_note"
         v-if="info.source_note">备注:{{info.source_note}}</div>
    <div class="content">
      <div class="topic_list">
        <TopicInfo ref="TopicInfoRef"
                   @setAnswer="setAnswer"
                   v-for="(item,idx) in info.questions"
                   :topic="item"
                   :topicIndex="idx"
                   :key="item.question_id" />
   
        <div class="btn_wrap">
               <div class="text">
        答题情况：
               </div>
      <div class="cards">
        <div class="card"
             @click="checkTopic(item,index)"
             v-for="(item,index) in copyTopicList"
             :key="index">
          <span v-if="getValue(item,index) != 'text'"
                :class="getValue(item,index) == index +1 ?'':'active'">{{getValue(item,index)}}</span>
          <div v-else
               :style="{'font-size':'14px','color':images.length?'#2395F5':'','background':images.length?'#EFF3FF':''}">
            <div>纸上作答</div>
            <div>上传图片</div>
          </div>
        </div>
      </div>
          <a-button  
           :class="{ submit_btn: true, disabled: useData.length == 0 }"
           
                    @click="submitPaper">
            提交
          </a-button>
        </div>
      </div>

      <div class="right_scroll">
        <RightScroll ref="rightScrollRef"
                     :topic_numer="topicNumber" />
      </div>
    </div>

    <SubmitDialog ref="submitDialogRef"
     :get-container="() => $refs.modalWrap"
                  @sava="sava" />
                  
    <explaindialog ref="explaindialogRef"
                   :dialogVisible="explaindialogVisible"
                   @expalinSubmitDapaper="expalinSubmitDapaper" />
    <backDialog ref="backDialogRef" />
    <pressDialog ref='pressDialogRef' />
  </div>
</template>

<script setup>
import explaindialog from './components/explain.vue'
import backDialog from './components/backDialog.vue'
import TopicInfo from './components/topic.vue'
import { reactive, ref  } from '@vue/reactivity'
import { watch ,computed } from 'vue'
import { nextTick, onActivated, onMounted, onUnmounted } from '@vue/runtime-core'
import { onBeforeRouteLeave, useRoute, useRouter } from 'vue-router'
import { getKnowledgePaper,getWrongPaperApi, getKnowledgeWeakPaper, getTemplatePaper, getTeacherPaper, getWholePaper, getChapterPaperApi, saveAnswer, getCapalilityTrain, continuePaper, submitPaper as submitPaperApi } from "@/api/paper.js"
import { message } from 'ant-design-vue'
import {skbDoPaper,skbContinuePaper,skbSubmitAnswer,skbSubmitUserAnswer } from '@/api/quick.js'
import TopCard from '@/views/components/top_card/index.vue'
import RightScroll from '@/views/components/right_card/index.vue'
import { uploadImageAuto } from '@/api/upload.js'
import { addHeader as globalAddHeader ,addAllHeader} from '@/init/index.js'
import { json } from 'body-parser'
// 使用答题卡那里的弹窗
import SubmitDialog from '@/views/doPaperCard/components/submitPaper1.vue'
import pressDialog from './components/topicPressDialog.vue'
import { checkArr as globalCheckArr } from '@/init/index.js'
import ExportPaper from '@/views/components/exportPaper/index.vue'
import Code from '@/views/doPaper/components/code/index.vue'
import TimeForm from './components/time.vue'


const route = useRoute()
const router = useRouter()
const explaindialogVisible = ref(false)
const rightScrollRef = ref(null)
const pressDialogRef = ref(null)
const codeRef = ref(null)
let uploadType = ref('all')
let form = reactive({})
let info = reactive({
  questions: []
})
// 存储所有题目的一维数组
let copyTopicList = ref([])
// 题目数，用于右侧滑块
let topicNumber = ref(0)
let images = ref([])
const addHeader = globalAddHeader
let checkArr = globalCheckArr
const submitDialogRef = ref(null)
let isFinish = ref(false) //用于判断退出页面时是提交还是半途退出
let startTimeing = ref(true)
let totalTime = ref(0)
let leftTimeContent = ref('00:00:00')
let clock = ref(null)
const timeFormRef = ref(null)
let numData = ref(0)
let useData = ref([])
 
onBeforeRouteLeave((to, from, next) => {
  if (to.fullPath != '/testpaper/card' && !isFinish.value) {
    save()
  }
  if (clock.value) {
    window.clearInterval(clock.value)
    clock.value = null
    window.localStorage.removeItem('exam_time_left')
  }
  next()
})
const getValue = (item, index) => {
  if (checkArr.indexOf(item.topic) != -1) {
    if (item.answer.length) {
      return item.answer.join(',')
    } else {
      return index + 1
    }
  } else {
    return 'text'
  }
}

watch(() => info.user_paper_id, () => {
  // codeRef.value.creatQrCode(info.user_paper_id)
}, { deep: true })

// onActivated(() => {
//   if (window.sessionStorage.getItem('testpaperCardIndex')) {
//     let paper = JSON.parse(window.sessionStorage.getItem('paper'))
//     images.value = JSON.parse(window.sessionStorage.getItem("images")) || []
//     let topicIndex = Number(window.sessionStorage.getItem('testpaperCardIndex'))
//     if (topicIndex) {
//       scrollToIndex(topicIndex)
//     } else {
//       nextTick(() => {
//         document.getElementsByClassName('content')[0].scrollTop = window.sessionStorage.getItem('scroll_top')
//       })
//     }
//     setInfo(paper)
//     setQuestionAnswerWarp(info.questions)
//   }
// })

// 点击反馈按钮,显示弹窗
const press = () => {
  pressDialogRef.value.dialogVisible = true
}
const back = () => {
  router.go(-1)
  // debugger
}
onMounted(() => {
  isFinish.value = false
  if (Number(window.sessionStorage.getItem('testpaperCardIndex'))) {
    let paper = JSON.parse(window.sessionStorage.getItem('paper'))
    images.value = JSON.parse(window.sessionStorage.getItem("images")) || []
    let topicIndex = Number(window.sessionStorage.getItem('testpaperCardIndex'))
    if (topicIndex) {
      scrollToIndex(topicIndex)
    } else {
      nextTick(() => {
        document.getElementsByClassName('content')[0].scrollTop = window.sessionStorage.getItem('scroll_top')
      })
    }
    setInfo(paper)
    topicNumber.value = 0
    setQuestionAnswerWarp(info.questions)
  }
  //  else if (route.query.isTeacherPaper) {
  //   // 处理从教师试卷过来的逻辑
  //   doTeacherPaper(JSON.parse(route.query.form))
  // }
  // 处理知识点/教师试卷过来的逻辑
  else if (route.query.isKnowledge || route.query.isChapter || route.query.isTeacherPaper || route.query.isKnowledgeWeak || route.query.isTemplate) {
    explaindialogVisible.value = true
  }
  else if (route.query.user_paper_id) {

    // 处理继续做题的情况
    if (route.query.isFrreeDom) {
      // 还有一种情况是从自由选题跳转过来的情况，拿了user_paper_id 在这里获取,因为是重新做的一套卷子  需要提示相应的注意事项
      explaindialogVisible.value = true
    }
    goOnPaper()
  } else {
    // 正常从试卷列表页面进来的情况
    window.sessionStorage.removeItem('testpaperCardIndex')
    window.sessionStorage.removeItem('paper')
    let queryForm = JSON.parse(route.query.form)
    for (const key in queryForm) {
      form[key] = queryForm[key]
    }
    window.sessionStorage.setItem('testpaperCardIndex', 0)
    // explaindialogVisible.value = true
    expalinSubmitDapaper()
    
  }
})

const setInfo = (paper) => {
  for (const key in paper) {
    info[key] = paper[key]
  }
  nextTick(() => {
    rightScrollRef.value.mountScrollEvent()
  })
  window.sessionStorage.setItem('user_paper_id', info.user_paper_id)

  if (info.paper_duration != 0) {
    setLeftTime()
  }
}

const setQuestionAnswerWarp = (arr) => {

  for (var index = 0; index < arr.length; index++) {
    arr[index].topic = String(arr[index].topic)
    if (arr[index].question_children) {
      arr[index].question_children = setQuestionAnswerWarp(arr[index].question_children)
    } else {
      topicNumber.value += 1
      if (arr[index].user_answer) {
        arr[index].answer = arr[index].user_answer.split(',')
      } else if (!(arr[index].answer instanceof Array)) {
        arr[index].answer = []
      }
      copyTopicList.value.push(arr[index])
    }

  }
  
 const hasAnswer = copyTopicList.value.some(item => Array.isArray(item.answer) && item.answer.length > 0);
if(!hasAnswer){
    useData.value.length =0
}else{
   
    useData.value.length =1
}
  return arr
   
}
const changeUploadType = ()=>{
  images.value = []
}

const setAnswer = (answer, index, topicIndex) => {
  let paperTest = info.questions[topicIndex]
  // 如果是多子题的话，需要index定位该题的位置
  if (paperTest.question_children && paperTest.question_children.length) {
    paperTest = paperTest.question_children[index]
  }
  /*
    在这里只会是小题的情况
  */
  //多选的情况下，再次点击，只会取消选择
  if (paperTest.answer.indexOf(answer) != -1) {
    paperTest.answer.splice(paperTest.answer.indexOf(answer), 1)
  } else if (paperTest.topic == '1') {
    //单选的情况
    paperTest.answer = [answer]
    //多选和不定项选，全部归为多选
  } else if (paperTest.topic == '2' || paperTest.topic == '3' || paperTest.topic == '4') {
    //双选
    // if (paperTest.answer.length == 2 && paperTest.topic == '4') {
    //   return
    // }
    paperTest.answer.push(answer)
  } else if (['9', '12','13', '14', '15'].indexOf(paperTest.topic) != -1) {
    paperTest.answer = [answer]
  }
  console.log(copyTopicList.value)
 const hasAnswer = copyTopicList.value.some(item => Array.isArray(item.answer) && item.answer.length > 0);
if(!hasAnswer){
    useData.value.length =0
}else{
    useData.value.length =1
}
 
  save()
}

const getAnswer = (topicList) => {
  var arr = []
  topicList.forEach(item => {
    if (item.answer.length != 0) {
      let answerStr = item.answer instanceof Array ? item.answer.join(',') : item.answer
      arr.push({ answer: answerStr, question_id: item.question_id })
    }
  })
  return arr
}

// 知识点组卷获取试卷
const getKnowledge = async () => {
  const { data } = await getKnowledgePaper(JSON.parse(route.query.form))
  topicNumber.value = 0
  data.list.questions = setQuestionAnswerWarp(data.list.questions)

  setInfo(data.list)
}

// 知识点弱点获取试卷
const getKnowledgeWeak = async () => {
  const { data } = await getKnowledgeWeakPaper(JSON.parse(route.query.form))
  topicNumber.value = 0
  data.list.questions = setQuestionAnswerWarp(data.list.questions)
  setInfo(data.list)
}
//能力素养组卷
const getCapWeak = async () => {
  const { data } = await getCapalilityTrain(JSON.parse(route.query.form))
  topicNumber.value = 0
  data.list.questions = setQuestionAnswerWarp(data.list.questions)
  setInfo(data.list)
}
const getTemplate = async () => {
  const { data } = await getTemplatePaper(JSON.parse(route.query.form))
  topicNumber.value = 0
  if(data.msg){
    message.success(data.msg)
  }
  data.list.questions = setQuestionAnswerWarp(data.list.questions)
  setInfo(data.list)

}

// 教师试卷
const doTeacherPaper = async (params) => {
  const { data } = await getTeacherPaper(params)
  topicNumber.value = 0

  data.list.questions = setQuestionAnswerWarp(data.list.questions)
  setInfo(data.list)
}
const getSkbDoPaper = async (params) => {
 
  const { data } = await skbDoPaper(params)
  topicNumber.value = 0

  data.list.questions = setQuestionAnswerWarp(data.list.questions)
  setInfo(data.list)
}
 
// 整卷做卷-模板做卷 getWholePaper
const getPaperInfo = async () => {
  const { data } = await getWholePaper(form)
  topicNumber.value = 0

  data.list.questions = setQuestionAnswerWarp(data.list.questions)
  setInfo(data.list)
}
//错题
 
const getWrongPaper = async ( ) => {
  const { data } = await getWrongPaperApi(JSON.parse(route.query.form))
  topicNumber.value = 0

  data.list.questions = setQuestionAnswerWarp(data.list.questions)
  setInfo(data.list)
}

// 章节组卷
const getChapterPaper = async () => {
  const { data } = await getChapterPaperApi({ chapter_id: route.query.chapter_id })
  topicNumber.value = 0

  data.list.questions = setQuestionAnswerWarp(data.list.questions)
  setInfo(data.list)
}

// 保存,做到一半退出页面-需保存答案
const save = async () => {
  if (!window.sessionStorage.getItem('user_paper_id')) {
    message.error("数据丢失")
    return
  }
  let data = {
    user_paper_id: window.sessionStorage.getItem('user_paper_id'),
    other_answer: images.value || JSON.parse(window.sessionStorage.getItem('images')) || [],
    user_answer: JSON.stringify(getAnswer(copyTopicList.value))
  }
  if (data.user_answer.length == '[]') {
    return
  }
  await skbSubmitUserAnswer(data)
}

// 点击答题卡
const card = (index) => {
  window.sessionStorage.setItem('paper', JSON.stringify(info))
  window.sessionStorage.setItem('testpaperCardIndex', 1)
  window.sessionStorage.setItem('images', JSON.stringify(images.value))

  var oapp = document.getElementsByClassName('content')[0]
  window.sessionStorage.setItem('scroll_top', oapp.scrollTop)

 router.push(`/testpaper/card?flag=1&show=${useData.value.length}`)
}

// 继续做卷
const goOnPaper = async () => {
  // console.log(route.query.flag)
  // if(route.query.flag == 'fdd'){
  const { data } = await skbContinuePaper({ user_paper_id: route.query.user_paper_id })
  // }else{
  //    const { data } = await continuePaper({ user_paper_id: route.query.user_paper_id })
  // }

  topicNumber.value = 0

  data.list.questions = setQuestionAnswerWarp(data.list.questions)
  setInfo(data.list)
  window.sessionStorage.setItem('images', JSON.stringify(info.other_answer || []))
}

// explain组件点击开始答题触发
const expalinSubmitDapaper = () => {
  if (route.query.isKnowledge) {
    getKnowledge()
  } else if (route.query.isKnowledgeWeak) {
    // 弱点训练
    getKnowledgeWeak()
  }
  else if (route.query.isCapability) {
    getCapWeak()
  }
  else if(route.query.isWrong){
    getWrongPaper()
  }
  else if (route.query.isTemplate) {
    getTemplate()
  } else if (route.query.isTeacherPaper && route.query.form) {
    // 处理从教师试卷过来的逻辑
    doTeacherPaper(JSON.parse(route.query.form))
  } else if( route.query.skb){
    getSkbDoPaper(JSON.parse(route.query.form))
  }else if (route.query.form) {
    // console.log(789)
    getPaperInfo()
  } else if (route.query.isChapter) {
    getChapterPaper()
  } 
  explaindialogVisible.value = false
}

const uploadImage = async (answer_id) => {
   
  if ( uploadType.value == 'all') {
    const { data } = await uploadImageAuto(20, "image/*")
  images.value.push(data.dir)
  message.success('上传成功')
}else{

 
  
   if (images.value[answer_id] && images.value[answer_id].length == 3) {
          message.info("每题最多可添加3张图片")
          return
        }
 
       const { data } = await uploadImageAuto(20, "image/*")
        const newImage = {
          [answer_id]: [
            addHeader(data.dir)
          ]
        }
        if ( images.value[answer_id]) {
            
           images.value[answer_id].push( addHeader(data.dir))
        }
        else {
          
           images.value = Object.assign({}, images.value, newImage);
        }
}
}
 

// 点击删除图片
const delteImage = (item, index) => {
  console.log(index, "让用户确认删除这个图片",item)
    console.log('image',images.value[item.answer_id])
  if(uploadType.value == 'all'){
 images.value.splice(index, 1)
  }else{
   
     if (images.value.hasOwnProperty(item.answer_id)) {  
           
        let imageArray =  images.value[item.answer_id]; 
          if (!Array.isArray(imageArray)) {
        // 假设您想将其值转换为数组
        imageArray = Object.values(imageArray);
      }
        console.log('imageArray',imageArray);
        
        if (index >= 0 && index < imageArray.length) {  
          
          images.value[item.answer_id].splice(index, 1); // 使用splice函数从数组中删除指定索引的元素
        }else{
          delete images.value[item.answer_id] 
        }
      }
  }
 
}

const scrollToIndex = (index) => {
  nextTick(() => {
    // 调用scroll方法就行
    rightScrollRef.value.toMaodian(index)
  })
}

// 提交试卷
const submitPaper = () => {
 
  let number = 0
   
const imageKeysCount = Object.keys(images.value).length;
 
  copyTopicList.value.forEach(item => {
    if (item.answer.length == 0 && checkArr.indexOf(item.topic) != -1) {
      number += 1
    } else if (images.value.length == 0 && checkArr.indexOf(item.topic) == -1) {
      number += 1
    }  else if(uploadType.value == "pre" && checkArr.indexOf(item.topic) == -1){
       number += 1
    }
  })
    
  if (imageKeysCount >0 && uploadType.value == "pre") {
  number -= imageKeysCount;
}
  numData.value = number 
   
   if(useData.value.length == 0){
     message.info("您还未作答，请继续作答")
return
  }
   
  submitDialogRef.value.setData(number, true)
}

const getAnswerUseCard = (topicList) => {
  var arr = {}
  topicList.forEach(item => {
    if (item.answer.length != 0) {
      let answerStr = item.answer instanceof Array ? item.answer.join(',') : item.answer
      arr[item.answer_id] = answerStr
    }
  })
  return arr
}

const sava = async () => {
if (Object.keys(images.value).length == 0 || images.value.length == 0) {
   
  images.value = '';
}
 
  let params = {
    user_paper_id: info.user_paper_id,
    other_answer: images.value==''?'':JSON.stringify(images.value),
    chs_answer: getAnswerUseCard(copyTopicList.value),
        num: topicNumber.value - numData.value
  }
  await skbSubmitAnswer(params)
  isFinish.value = true
  router.push('/report')
  message.success("提交成功")
  window.sessionStorage.removeItem('images')
  window.sessionStorage.removeItem('paper')
}

const setLeftTime = () => {
  if (clock.value) return
  totalTime.value = window.localStorage.getItem('exam_time_left')
  totalTime.value = totalTime.value ? totalTime.value : info.paper_duration*60
  if (totalTime.value <= 0) return
  clock.value = window.setInterval(() => {
    totalTime.value--
    window.localStorage.setItem('exam_time_left', totalTime.value)
    leftTimeContent.value = leftTimeFormat(totalTime.value)
    if (totalTime.value <= 0) {
      window.clearInterval(clock.value)
      window.localStorage.removeItem('exam_time_left')
      totalTime.value = 0
      leftTimeContent.value = '00:00:00'
      this.$message.warning('做卷时间已到，系统将自动提交试卷')
      startTimeing.value = false
      // submitPaper()
    }
  }, 1000)
}
const leftTimeFormat = (totalSeconds) => {
  const hours = Math.floor(totalSeconds / 3600);
  const remainingSeconds = totalSeconds % 3600;
  const mins = Math.floor(remainingSeconds / 60);
  const secs = remainingSeconds % 60;

  const format = (num) => {
      const parts = num.toString().split('.');
      parts[0] = parts[0].padStart(2, '0');
      return parts.join('.');
  };

  return `${format(hours)}:${format(mins)}:${format(secs)}`;
}
const setTimeing = (handleSet) => {
  if (handleSet != undefined) {
    startTimeing.value = handleSet
  } else {
    startTimeing.value = !startTimeing.value
  }
  if (startTimeing.value) {
    setLeftTime()
  } else {
    window.clearInterval(clock.value)
    clock.value = null
  }
}
const toSetTime = () => {
  if (totalTime.value != 0) {
    timeFormRef.value.editTime = false
  }
  timeFormRef.value.leftTime = Math.round(totalTime.value/60)
  timeFormRef.value.totalTime = info.paper_duration
  timeFormRef.value.timeDialogVisible = true
}
const setTimeSubmit = (time) => {
  totalTime.value = time*60
  setTimeing(false)
  setTimeing(true)
}
</script>

<style lang="scss" scoped>
  ::v-deep .ant-modal-content{
 
border-radius: 32rem;
 
}
::v-deep .ant-modal-header{
  padding:32rem 24rem;
}
.active {
  background-color: #ecf5fc !important;
  color: #2196f3;
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
}
::v-deep .xiao_warp  {
  width: calc(99vw - 140rem);
  background: white;
  overflow: auto;
  padding: 10px;
  margin: 0 0 20rem 40rem;
}
::v-deep .warp  {
  width: calc(99vw - 140rem);
  background: white;
  overflow: auto;
  padding: 10px;
  margin: 0 0 20rem 40rem;
}
::v-deep .right_card_wrap{
  top:152rem;
  height:80vh
}
.info_warp {
  width: 100vw;
  background: #f6f6f6;
    padding-top: 40rem;
    height: 100vh;
   .top {
    width: 1856rem;
   justify-content: space-between;
    align-items: center;
    gap: 10rem;
    margin-left: 32rem;
    display: flex;
    border-radius: 32rem;
    background: #fff;
    height: 80rem;
    padding: 0 24rem;
    // justify-content: center;
    color: var(--light-333333, #333);
    text-align: center;

    font-size: 28rem;
    font-style: normal;
    font-weight: 600;
    line-height: 42rem; /* 150% */
    img {
      width: 48rem;
      height: 48rem;
    }
  }
  .paper_id {
    display: flex;
    gap: 5rem;
    padding: 10rem 30rem;
    font-size: 20rem;
    font-weight: 700;
  }
  .content {
    flex: 1;
    display: flex;
    height: calc(100vh - 170rem);
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 40rem;
      .cards {
    // margin-left: 20px;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    margin-top: 20rem;
    .card{
      width: 120rem;
      height: 120rem;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #666666;
      font-weight: bold;
      font-size: 32rem;
      margin-right: 24rem;
      margin-bottom: 30rem;
      background: #f6f6f6;
      
  background: #f6f6f6;
   color: #666666;
      border-radius: 10rem;
      cursor: pointer;
    }
  }
  }
  .right_scroll {
    flex-shrink: 0;
    width: 100rem;
    margin-left: 20rem;
  }
}

.image_wrap {
  background: #ffffff;
  margin-left: 20rem;
  margin-top: 20rem;
  padding: 30rem;
  box-shadow: inset 0rem -1rem 0rem 0rem rgba(229, 229, 229, 1);
  .title {
    font-size: 20rem;
    font-weight: bold;
    color: #333333;
    span {
      color: #848484;
    }
  }
 .img_list {
    margin-top: 30rem;
    margin-left: 40rem;
    display: flex;
    flex-wrap: wrap;
     .image {
    position: relative;
    width: 120rem;
    height: 120rem;
    margin-right: 24rem;
    justify-content: center;
    .close {
      position: absolute;
      right: -5px;
      top: -5px;
      background: red;
      color: white;
      width: 30rem;
      height: 30rem;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 8px;
      z-index: 19;
    }
  }
    .img_card {
      display: flex;
      width: 610rem;
      margin-top: 10px;
    }
    .img_wrap {
      position: relative;
      // margin-right: 24rem;
      display: flex;
      // width: 120rem;
      height: 120rem;
   
    .close {
      position: absolute;
      right: -5px;
      top: -5px;
      background: red;
      color: white;
      width: 30rem;
      height: 30rem;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 8px;
      z-index: 19;
    }
      .del {
        position: relative;
        right: 15rem;
        top: -9rem;
        width: 30rem;
        height: 30rem;
        cursor: pointer;
      }
      .answer {
        border-radius: 10rem;
        width: 116rem;
        height: 120rem;
      }
    }
    .add_img {
      width: 120rem;
      height: 120rem;
      background: #f6f6f6;
      border-radius: 10rem;
      font-size: 20rem;
      font-weight: 500;
      color: #2196f3;
      text-align: center;
      cursor: pointer;
      img {
        width: 40rem;
        height: 34rem;
        margin-top: 26rem;
        margin-bottom: 6rem;
      }
    }
  }
  .add_img {
    width: 120rem;
    height: 120rem;
    background: #f6f6f6;
    border-radius: 10rem;
    font-size: 20rem;
    font-weight: 500;
    color: #2196f3;
    text-align: center;
    cursor: pointer;
    img {
      width: 40rem;
      height: 34rem;
      margin-top: 26rem;
      margin-bottom: 6rem;
    }
  }
}
.right_card {
  margin-right: 70rem;
  img {
    width: 36rem;
    height: 36rem;
    margin-right: 30rem;
    cursor: pointer;
    &:last-child {
      margin-right: 0;
    }
  }
}

.img_warp {
  display: flex;
  margin-left: 20px;
  margin-top: 19px;
  .image {
    position: relative;
    width: 120rem;
    height: 120rem;
    margin-right: 24rem;
    justify-content: center;
    .close {
      position: absolute;
      right: -5px;
      top: -5px;
      background: red;
      color: white;
      width: 30rem;
      height: 30rem;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 8px;
      z-index: 19;
    }
  }
  .add_img {
    width: 120rem;
    height: 120rem;
    font-size: 20rem;
    font-weight: 500;
    background: #f6f6f6;
    border-radius: 10rem;
    text-align: center;
    color: #2196f3;
    cursor: pointer;
    img {
      width: 40rem;
      height: 34rem;
      margin-top: 26rem;
      margin-bottom: 14rem;
    }
  }
}
.btn_wrap {
  // height: 120rem;
   background: #fff;
   margin-left: 40rem;
   padding:40rem;
   .text{
    color: var(--light-333333, #333);
 
font-size: 20px;
font-style: normal;
font-weight: 600;
line-height: 30px; /* 150% */
   }
   .disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
  .submit_btn {
    width: calc(100% - 20rem);
    // margin-left: 20rem;
    margin-top: 60rem;
    height: 60rem;
    background: #2196f3;
    border-radius: 10rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24rem;
    font-weight: bold;
    color: #ffffff;
    cursor: pointer;
  }
}
.source_note {
  padding: 5rem 30rem;
  font-size: 20rem;
  margin-top: -10rem;
  margin-bottom: 20rem;
}
</style>